var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsRead',{attrs:{"modelName":_vm.modelName,"id":_vm.$route.params.id,"localeMode":_vm.localeMode,"label":_vm.label,"fields":_vm.fields,"primary":_vm.pageSetting.primary,"secondary":_vm.pageSetting.secondary,"titleKey":"remark"}})}
var staticRenderFns = []

export { render, staticRenderFns }